import React, { FC } from 'react';
import styled from 'styled-components';
import { getGlobalConfig } from '../global/ConfigProvider';

const A = styled.a`
  ${({ hellip }) => (hellip ? 'display: inline-block;' : '')}
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #3492bd;
`;

interface IProps {
  'data-testid'?: string;
  id: number;
  title?: string;
  hellip?: boolean;
}

export const AILink: FC<IProps> = ({
  id,
  title,
  'data-testid': testId,
  hellip = true,
}) => {
  const { baseAppUrl } = getGlobalConfig();
  return (
    <A
      href={`${baseAppUrl}/actionitem?id=${id}`}
      target="_blank"
      title={title ? `${id} ${title}` : `${id}`}
      data-testid={testId}
      hellip={hellip}
    >
      {title ?? id}
    </A>
  );
};
